import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IBetalingStatus } from '@/model/IBetalingStatus';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { appBetalingenService } from '@/services/appBetalingenService';

@Component({})
export default class AppBetalingError extends Mixins(AppFiltersMixin) {
  @Prop()
  public status!: IBetalingStatus;

  public get canRetry(): boolean {
    return !!this.status.paymentProviderRedirectUri && this.status.paymentProviderStatus === 'open';
  }

  public annuleerBetaling() {
    appBetalingenService
      .cancelBetaling(this.$route.params.betalingId)
      .then(() => this.$router.push({ name: 'hypotheek' }));
  }
}
